import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from '../../../services/delivery-order.service';
import { WarehousingCreationService } from '../../../services/warehousing-creation.service';

@Component({
  selector: 'laas-warehousing-upload',
  templateUrl: './warehousing-upload.component.html',
  styleUrls: ['./warehousing-upload.component.scss']
})
export class WarehousingUploadComponent extends SessionBaseComponent implements OnInit{

  isLoading: boolean = false;
  previewData : any[] = [];
  showTable: boolean = false;
  uploadBtn: boolean = true;
  warehousingFile : any;



  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private dOService: DeliveryOrderService,
    private dropdownOptionsService: DropdownOptionsService,
    private warehousingCreationService : WarehousingCreationService,
    private facilityService : FacilityService,
    private http: HttpClient
    ) {
    super(injector);

  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }


  preview(event: any): void{

    console.log("preview");
    this.showTable = false;
    this.isLoading = true;
    this.uploadBtn = true;
    this.warehousingFile = [];
    this.loader.show();
    this.warehousingCreationService.preview( event.files[0]).subscribe({
      next: rsp => {

        console.log("rsp:",rsp);

        if(rsp.message == "FAIL"){
          this.toastService.info(this.translateService.instant('ReceiptFormQuery.Alert.FileFormatError'),false);
          return;
        }

        this.previewData = rsp.previewData ?? [];
        this.showTable = this.previewData.length > 0;

        // 顯示錯誤訊息（如有）
        if (rsp.errors && rsp.errors.length > 0) {
          this.toastService.error(rsp.errors.join('\n'));
        }

        // 只有當有有效資料列時才解鎖上傳按鈕
        const hasValidRows = typeof rsp.validRowCount === 'number'
          ? rsp.validRowCount > 0
          : this.previewData.length > 0;
        this.warehousingFile = hasValidRows ? event.files[0] : null;
        this.uploadBtn = !hasValidRows;

        if (hasValidRows) {
          this.toastService.success(this.translateService.instant('ReceiptFormQuery.Success.PreviewSuccess'),false);
        }
        this.isLoading = false;
        this.loader.hide()
      },
      error: rsp => {
        console.log(rsp);
        this.isLoading = false;
        this.toastErrorMessage(rsp.error);
        this.loader.hide()
      },
      complete: () => {
        this.loader.hide()
      }
    });
  }

  upload(): void{

    this.isLoading = true;
    this.loader.show()
    this.warehousingCreationService.uploadFile(this.warehousingFile, this.userProfile.userName).subscribe({
      next: rsp => {
        this.showTable = false;
        this.previewData = [];
        this.warehousingFile = null;
        this.isLoading = false;
        this.uploadBtn = true;
        this.loader.hide();

        // Partial-success: show row errors if any rows failed
        if (rsp && rsp.failCount > 0) {
          this.toastBatchImportResult(rsp);
        }

        if (rsp && rsp.successCount > 0) {
          // Only a positive persisted-row count is an upload success.
          this.toastService.success(
            this.translateService.instant('ReceiptFormQuery.Success.UploadSuccess') +
            (rsp.failCount > 0 ? ` (${rsp.successCount} 筆)` : ''), false);
        } else if (!rsp || rsp.failCount === 0) {
          // A 2xx response with no persisted or failed rows is not success.
          this.toastService.error('沒有資料成功匯入');
        }
      },
      error: rsp => {
        console.log(rsp);
        this.isLoading = false;
        this.toastErrorMessage(rsp.error);
        this.loader.hide()
      },
      complete: () => {
        this.loader.hide()
      }
    });

  }


  onClear() {
    this.showTable = false;
    this.uploadBtn = true;
  }

  showUploadBtn() {
    if (this.uploadBtn) {
      return true;
    } else {
      return false;
    }
  }

  templateDownloadBtn(): void{

    var fileType = 'WarehousingTemplate';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' });
          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'WarehousingTemplate.xlsx';
          link.click();
        });
      }
    });
  }

}
